import React, { useState, useEffect } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import DataTable from "react-data-table-component";
import { Filter, Download } from "react-feather";
import { Dropdown } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import ReportNavbar from "./AdminComp/ReportNavbar";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import { Link } from "react-router-dom";
import { Spinner } from 'react-bootstrap'; // Import the Spinner from react-bootstrap

const SellerReport = () => {
  const [sellers, setSellers] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state

  // Fetch seller data from API on component mount
  useEffect(() => {
    const fetchSellers = async () => {
      try {
        const response = await axios.get(`${baseurl}getAllSellersAdmin`);
        console.log("response", response);   
        if (response.data.message === "Sellers fetched successfully") {
          setSellers(response.data.data);
          setFilteredData(response.data.data);  // Initializing filteredData with all sellers
        }
      } catch (error) {
        console.error("Error fetching seller data", error);
      } finally {
        setLoading(false); // Set loading to false after the data is fetched
      }
    };

    fetchSellers();
  }, []);

  // Define columns for DataTable
  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: "Seller Name",
      selector: (row) => `${row.first_name} ${row.middle_name ? row.middle_name + ' ' : ''}${row.last_name}`,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.seller_email,
      sortable: true,
    },
    {
      name: "Phone",
      selector: (row) => row.phone,
      sortable: true,
    },
    {
      name: "OTP Verified",
      selector: (row) => (row.otp_verified ? "Yes" : "No"),
      sortable: true,
    },
    {
      name: "Created At",
      selector: (row) => new Date(row.created_at).toLocaleString(),
      sortable: true,
    },
   
  ];

  // Handle Excel Download
  const handleDownloadExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Seller Report");
    XLSX.writeFile(wb, "seller_report.xlsx");
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />

      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <ReportNavbar />
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="text-start">Seller Report</h4>
            <div className="d-flex align-items-center">
              <input
                type="text"
                className="form-control me-2"
                placeholder="Search Sellers"
                onChange={(e) =>
                  setFilteredData(
                    sellers.filter((seller) =>
                      `${seller.first_name} ${seller.middle_name || ""} ${seller.last_name}`
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                    )
                  )
                }
              />
              <Dropdown className="me-2">
                <Dropdown.Toggle className="form-control prwcl" id="dropdown-basic">
                  <Filter size={16} /> Status Filter
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setFilteredData(sellers)}>All</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              <span className="btn btnsuccess" onClick={handleDownloadExcel}>
                <Download size={17} />&nbsp;Download
              </span>
            </div>
          </div>

          <div className="card">
            <div className="card-body" style={{ padding: 0 }}>
              <div style={{ overflowX: "auto", maxHeight: "400px" }}>
                {loading ? (
                  <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
                    <Spinner animation="border" role="status">
                      <span className="sr-only">Loading...</span>
                    </Spinner>
                  </div>
                ) : (
                  <DataTable
                    columns={columns}
                    data={filteredData}
                    pagination
                    highlightOnHover
                    responsive
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SellerReport;
